/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Duration_Unknown_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to determine the duration of the source media file." |
*
* @param {Audio_Description_Export_Duration_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_duration_unknown_error = /** @type {((inputs?: Audio_Description_Export_Duration_Unknown_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Duration_Unknown_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de determiner la duree du fichier media source.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Dauer der Quellmediendatei konnte nicht ermittelt werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile determinare la durata del file multimediale di origine.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось определить продолжительность исходного медиафайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede determinar la duración del archivo multimedia de origen.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法确定源媒体文件的持续时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース メディア ファイルの継続時間を特定できません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत मीडिया फ़ाइल की अवधि निर्धारित करने में असमर्थ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível determinar a duração do arquivo de mídia de origem.")
	return /** @type {LocalizedString} */ ("Unable to determine the duration of the source media file.")
});